import React from "react"; 
import { Link } from "react-router-dom";    
import CustomerOrdersListContent from "../../../components/Dashboard/CustomerOrdersListContent";

const CustomerOrdersList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Customer Orders List</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Customer Orders List</li>
        </ul>
      </div> */}

      <CustomerOrdersListContent />
    </>
  );
};

export default CustomerOrdersList;
